import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { athensGray, cinderella, bsBlue, white } from 'constants/colors';

export const useStyles = makeStyles()((theme: Theme) => {
  return {
    wrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      padding: '2px 10px 2px 0',
      borderRadius: '24px',
      whiteSpace: 'pre',

      [theme.breakpoints.up('lg')]: {
        justifyContent: 'center',
      },
    },
    expired: { backgroundColor: athensGray },
    time: { backgroundColor: cinderella },
    icon: {
      margin: '0 5px 0 10px',
    },

    // New
    newRoot: {},
    heading: {
      background: bsBlue,
      padding: '6px 0',
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,

      '& .MuiTypography-root': {
        color: white,
        fontSize: '1.6rem',
        fontWeight: 400,
        textAlign: 'center',
      },
    },
    display: {
      fontFamily: `'digital-7regular'`,
      fontWeight: 400,
      fontSize: '6.4rem',
      lineHeight: '35px',
      textAlign: 'center',
      color: '#3889FA',
      padding: '23px 0',
      '& span': {
        fontVariantNumeric: 'tabular-nums',
        display: 'inline-block',
        width: 61,
        textAlign: 'left',
      },
    },
    timerTiny: {
      background: '#3889FA',
      borderRadius: 10,
      padding: '4px 25px',

      '& .MuiTypography-root': {
        padding: 0,
        fontSize: '1.4rem',
        lineHeight: '0.8rem',
        textAlign: 'center',
        color: '#FFFFFF',
        '& span': {
          width: 14,
        },
      },
    },
  };
});
